module.exports = __webpack_public_path__ + "assets/GTAmerica-ExtendedBlack.eot";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/fonts/GTAmerica-ExtendedBlack.eot
// module id = 1006
// module chunks = 19